<template>
  <div class="home-scene-body">
    <div>
      <div class="home-scene-list">
        <div class="home-title">
          <p>热门场景</p>
          <!-- <span>查看更多 ></span> -->
        </div>
        <div class="home-scene-list-content">
          <div
            v-for="item in topicList"
            :key="item.id"
            @click="scenesTopic(item.id)"
          >
            <images
              :id="
                item.coverAttachment ? item.coverAttachment.attachmentId : ''
              "
            />
            <span>{{ item.topicName }}</span>
          </div>
        </div>
      </div>
      <div class="home-service-list">
        <div class="home-title">
          <p>热门服务</p>
        </div>
        <div class="home-service-list-content">
          <div @click="consult('1')">
            <div>
              <p>场景寻源</p>
              <span>Scene Sourcing</span>
            </div>
            <img src="@/assets/img/arrow-right-circle.png" />
          </div>
          <div @click="consult('2')">
            <div>
              <p>场景辅导</p>
              <span>Scene Coaching</span>
            </div>
            <img src="@/assets/img/arrow-right-circle.png" />
          </div>
          <div @click="consult('3')">
            <div>
              <p>揭榜寻源</p>
              <span>Unveiling The Source</span>
            </div>
            <img src="@/assets/img/arrow-right-circle.png" />
          </div>
          <div @click="noUrl">
            <div>
              <p>场景伴行</p>
              <span>Scene Companion</span>
            </div>
            <img src="@/assets/img/arrow-right-circle.png" />
          </div>
        </div>
      </div>
    </div>
    <consult-form
      v-if="consultShow"
      :show="consultShow"
      :type="consultType"
      v-model="consultShow"
    />
  </div>
</template>

<script>
import { getHomeTopicList } from "@/api/topic";
import images from "@/page/components/image";
import consultForm from "../../consult/consultForm.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    images,
    consultForm,
  },
  data() {
    return {
      topicList: [],
      consultType: "",
      consultShow: false,
    };
  },
  computed: mapGetters(["userInfo"]),
  mounted() {
    this.loadgetHomeTopicList();
  },
  methods: {
    noUrl(){
      this.$message.warning("暂无跳转链接！")
    },
    loadgetHomeTopicList() {
      let page = {
        current: 1,
        size: 6,
      };
      getHomeTopicList(page).then((res) => {
        this.topicList = res.data.records;
      });
    },
    scenesTopic(id) {
      this.$router.push({
        path: "/homeScenes/scenesTopic",
        query: { id },
      });
    },
    consult(type) {
      if (!this.userInfo) {
        this.$message.warning("您还未登录！");
        return;
      }
      this.consultType = type;
      this.consultShow = true;
    },
  },
};
</script>

<style lang="less" scoped>
.home-scene-body {
  background: #fff;
  padding-bottom: 40px;
  > div {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .home-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      > p {
        font-size: 24px;
        line-height: 24px;
        padding-left: 12px;
        border-left: 4px solid #1abc9c;
        font-weight: 400;
      }
      > span {
        line-height: 14px;
        color: #8c8c8c;
        cursor: pointer;
      }
    }
    .home-scene-list {
      flex: 1;
      .home-scene-list-content {
        display: flex;
        flex-wrap: wrap;
        > div {
          width: 282px;
          height: 144px;
          margin-right: 24px;
          margin-top: 24px;
          background-size: 100% 100%;
          position: relative;
          cursor: pointer;
          > img {
            width: 100%;
            height: 100%;
          }
          &:nth-child(3n) {
            margin-right: 0;
          }
          > span {
            position: absolute;
            text-shadow: 3px 3px 0px rgba(0, 0, 0, 0.16);
            font-size: 24px;
            left: 22px;
            top: 50%;
            transform: translateY(-50%);
            font-weight: bold;
            color: #fff;
          }
        }
      }
    }
    .home-service-list {
      width: 282px;
      margin-left: 24px;
      .home-service-list-content {
        background: linear-gradient(0deg, #f2f6f9 0%, #f7f9f9 100%);
        padding: 20px 16px;
        margin-top: 40px;
        > div {
          width: 100%;
          height: 56px;
          margin-bottom: 16px;
          background-size: 100% 100% !important;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px;
          color: #fff;
          cursor: pointer;
          &:last-child {
            margin-bottom: 0;
          }
          &:nth-child(1) {
            background: url(../../../assets/img/tj1.png) no-repeat;
          }
          &:nth-child(2) {
            background: url(../../../assets/img/tj2.png) no-repeat;
          }
          &:nth-child(3) {
            background: url(../../../assets/img/tj3.png) no-repeat;
          }
          &:nth-child(4) {
            background: url(../../../assets/img/tj4.png) no-repeat;
          }
          > div {
            > p {
              font-size: 16px;
              line-height: 16px;
              margin-bottom: 6px;
              font-weight: bold;
            }
            > span {
              display: block;
              font-size: 12px;
              line-height: 12px;
              opacity: 0.4;
            }
          }
          > img {
            opacity: 0;
            transition: all 0.3s;
          }
          &:hover {
            > img {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
</style>
